import { render } from "./menu.vue?vue&type=template&id=44f45c4e&scoped=true&ts=true"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"

import "./menu.vue?vue&type=style&index=0&id=44f45c4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f45c4e"]])

export default __exports__